import React from 'react';

import NewDynamicTable from '../shared/NewDynamicTable';

import Dialog from '@material-ui/core/Dialog';
//import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

import { withStyles, responsiveFontSizes } from '@material-ui/core/styles';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

import {getStyle} from '../../styles/styles';

import { getDealEmailLogsByDeal } from '../../networking/NetworkingDeals';

var style = getStyle();

const styles = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });  

export default class DealEmailLogForm extends React.Component {

    state = {
        customerName: "",
        sentBy: "",
        sentDate: "",
        emailType: "",
        mainRecipient: [{"Main Recipient":""}],
        ccRecipient: "",
        bccRecipient: "",
        listEmailLogs: [{
            "Sent On": "",
            "Sent By": "",
            Type: ""
        }],
        listEmailLogs: []
    }

    componentDidMount() {
        if (typeof this.props !== "undefined" && this.props !== null && typeof this.props.dealHeaderId != "undefined") {
            this.getAllDealEmailLogs();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.dealHeaderId !== this.props.dealHeaderId) {
            this.getAllDealEmailLogs();
        }
    } 

    handleBackLink = () => {
        this.setState({}, () => this.props.backLink());
    }

    getAllDealEmailLogs = async () => {
        var json = await getDealEmailLogsByDeal(this.props.dealHeaderId, 0);
        var helper = this.transformList(json.dealEmailLogs);  
        this.setState({ listEmailLogs: helper })
    }

    transformList(list) {
        var helper = [];
        if(list && list.length > 0)
        {
            for (var i = 0; i < list.length; i++) {
                helper.push({
                    'Sent On': list[i]['Sent On'],
                    'Sent By': list[i]['Sent By'],
                    'Type': list[i].Type,
                    'MainRecipient': list[i].MainRecipient,
                    'CCRecipient': list[i].CCRecipient,
                    'BCCRecipient': list[i].BCCRecipient
                });
            }
        }
        return helper;
    }

    handleRowClick(obj){
        debugger;
        var tempMainRecipient = this.state.mainRecipient;
        if(obj.MainRecipient != null){
            tempMainRecipient = []
            let mainRecipientList = obj.MainRecipient.split(";");
            for (var i = 0; i < mainRecipientList.length; i++) {
                if(mainRecipientList[i] != ''){
                    tempMainRecipient.push({'MainRecipient': mainRecipientList[i]});
                }
            }
        }
        var tempCcRecipient = this.state.ccRecipient;
        if(obj.CCRecipient != null){
            tempCcRecipient = []
            let ccRecipientList = obj.CCRecipient.split(";");
            for (var i = 0; i < ccRecipientList.length; i++) {
                if(ccRecipientList[i] != ''){
                    tempCcRecipient.push({'CCRecipient': ccRecipientList[i]});
                }
            }            
        }
        var tempBccRecipient = this.state.bccRecipient;
        if(obj.BCCRecipient != null){
            tempBccRecipient = []
            let bccRecipientList = obj.BCCRecipient.split(";");
            for (var i = 0; i < bccRecipientList.length; i++) {
                if(bccRecipientList[i] != ''){
                    tempBccRecipient.push({'BCCRecipient': bccRecipientList[i]});
                }
            }                   
        }
        this.setState({ emailType: obj["Type"], sentBy: obj["Sent By"], sentDate: obj["Sent On"], mainRecipient: tempMainRecipient, ccRecipient: tempCcRecipient, bccRecipient: tempBccRecipient});
    }

    render() { 
        return(
            <Dialog 
                open        ={this.props.open} 
                onClose     ={this.handleBackLink}
                fullWidth   ={true}
                maxWidth    ={"md"}
            >
                <DialogTitle 
                    id      = "customized-dialog-gwlatr-title"
                    onClose = {this.handleBackLink}
                >
                    Deal Email Log
                </DialogTitle>
                <DialogContent dividers style={{paddingLeft:24}} >
                    <div className="uk-grid">
                        {/*Line1*/}
                        {/*<div className="uk-width-1-3">
                            <label className="uk-form-label">Customer Name</label>
                            <input className="uk-input" type="text" value={this.state.customerName} readOnly/>
                        </div>*/}
                        <div className="uk-width-1-3">
                            <label className="uk-form-label">Email type</label>
                            <input className="uk-input" type="text" value={this.state.emailType} readOnly/>
                        </div>
                        <div className="uk-width-2-3"> </div>
                        
                        {/*Line2*/}
                        <div className="uk-width-1-3">                        
                            <label className="uk-form-label">Sent By</label>
                            <input className="uk-input" type="text" value={this.state.sentBy} readOnly/>
                        </div>
                        <div className="uk-width-2-3"> </div>

                        {/*Line3*/}
                        <div className="uk-width-1-3">                        
                            <label className="uk-form-label">Sent Date</label>
                            <input className="uk-input" type="text" value={this.state.sentDate} readOnly/>
                        </div>
                        <div className="uk-width-2-3"> </div>

                        {/*Line4*/}
                        <div className="uk-width-1-3">       
                            <NewDynamicTable data={this.state.mainRecipient}/*data={[{"Main Recipient":""}]}*//>                 
                            </div>

                        <div className="uk-width-1-3">
                            <NewDynamicTable data={[{"C.C. Recipient":""}]}/>
                        </div>
                        <div className="uk-width-1-3">
                            <NewDynamicTable data={[{"B.C.C Recipient":""}]}/>
                        </div>

                        {/*Line5*/}
                        <div className="uk-width-1-1">
                            <h4>Email Logs</h4>
                            <NewDynamicTable 
                                hiddenHeaders={['CCRecipient','BCCRecipient']} 
                                data={this.state.listEmailLogs}
                                clickFunction={this.handleRowClick.bind(this)}/>
                        </div>

                        <div className="uk-width-1-1" style={{paddingTop:10}}>
                            <button 
                                className="uk-button uk-button-green uk-float-right" 
                                type="button" 
                                onClick={this.handleBackLink}
                            >Close</button>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        );        
    }
}